import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import { useToast } from '../../components/base/ToastContainer';

export default function FormLoginPage() {
  const navigate = useNavigate();
  const toast = useToast();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const trimmedEmail = email.trim().toLowerCase();
      const trimmedPassword = password.trim();

      console.log('🔐 Giriş denemesi başladı');
      console.log('📧 Email:', trimmedEmail);
      console.log('🔑 Şifre uzunluğu:', trimmedPassword.length);

      if (!trimmedEmail || !trimmedPassword) {
        console.log('❌ Boş alan var!');
        toast.error('Lütfen tüm alanları doldurun!');
        setLoading(false);
        return;
      }

      // form_users tablosundan kullanıcıyı kontrol et
      console.log('🔍 Veritabanında kullanıcı aranıyor...');
      const { data: formUser, error: formUserError } = await supabase
        .from('form_users')
        .select('*')
        .ilike('email', trimmedEmail)
        .maybeSingle();

      console.log('📊 Sorgu sonucu:', { formUser, formUserError });

      if (formUserError) {
        console.error('❌ Veritabanı hatası:', formUserError);
        toast.error('Bir hata oluştu! Lütfen tekrar deneyin.');
        setLoading(false);
        return;
      }

      if (!formUser) {
        console.log('❌ Kullanıcı bulunamadı!');
        toast.error('E-posta veya şifre hatalı!');
        setLoading(false);
        return;
      }

      console.log('✅ Kullanıcı bulundu:', formUser.full_name);
      console.log('👤 Kullanıcı bilgileri:', {
        email: formUser.email,
        isActive: formUser.is_active,
        passwordLength: formUser.password?.length
      });

      // Aktif mi kontrol et
      if (!formUser.is_active) {
        console.log('❌ Hesap aktif değil!');
        toast.error('Hesabınız aktif değil! Lütfen yöneticinizle iletişime geçin.');
        setLoading(false);
        return;
      }

      // Şifre kontrolü
      const storedPassword = formUser.password || '';
      const isPasswordValid = trimmedPassword === storedPassword;

      console.log('🔐 Şifre kontrolü detayları:');
      console.log('  Girilen şifre:', trimmedPassword);
      console.log('  Veritabanı şifresi:', storedPassword);
      console.log('  Eşleşme durumu:', isPasswordValid);

      if (!isPasswordValid) {
        console.log('❌ Şifre eşleşmedi!');
        toast.error('E-posta veya şifre hatalı!');
        setLoading(false);
        return;
      }

      console.log('🎉 Giriş başarılı! Yönlendiriliyor...');
      toast.success('Giriş başarılı!');
      
      // Kullanıcı bilgilerini localStorage'a kaydet
      localStorage.setItem('form_user', JSON.stringify({
        id: formUser.id,
        email: formUser.email,
        full_name: formUser.full_name,
        role: formUser.role || 'user',
        isAdmin: false
      }));

      console.log('💾 LocalStorage kaydedildi');

      setTimeout(() => {
        console.log('🚀 Ana sayfaya yönlendiriliyor...');
        navigate('/', { replace: true });
      }, 500);

    } catch (error) {
      console.error('❌ Beklenmeyen hata:', error);
      console.error('❌ Hata detayı:', JSON.stringify(error, null, 2));
      toast.error('Bir hata oluştu! Lütfen tekrar deneyin.');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 via-white to-orange-50 flex items-center justify-center p-6">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 bg-white/80 backdrop-blur-md border-b border-gray-200 z-50">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl flex items-center justify-center">
                <i className="ri-file-list-line text-xl text-white"></i>
              </div>
              <span className="text-lg font-bold text-gray-900">Form Giriş</span>
            </div>
            <button
              onClick={() => navigate('/login')}
              className="px-4 py-2 text-sm font-medium text-gray-700 hover:text-teal-600 transition-colors flex items-center gap-2 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-admin-line"></i>
              <span>Admin Girişi</span>
            </button>
          </div>
        </div>
      </header>

      <div className="w-full max-w-md mt-20">
        <div className="bg-white rounded-2xl shadow-xl p-8">
          {/* Logo ve Başlık */}
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <i className="ri-file-list-line text-3xl text-white"></i>
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Form Giriş</h1>
            <p className="text-sm text-gray-600">Müşteri formu doldurmak için giriş yapın</p>
          </div>

          {/* Login Form */}
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                E-posta Adresi
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                  <i className="ri-mail-line text-gray-400"></i>
                </div>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full pl-11 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                  placeholder="ornek@email.com"
                  required
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Şifre
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                  <i className="ri-lock-line text-gray-400"></i>
                </div>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full pl-11 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                  placeholder="••••••••"
                  required
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-gradient-to-r from-teal-500 to-teal-600 text-white py-3 rounded-lg font-medium hover:from-teal-600 hover:to-teal-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
            >
              {loading ? (
                <>
                  <i className="ri-loader-4-line animate-spin"></i>
                  Giriş yapılıyor...
                </>
              ) : (
                <>
                  <i className="ri-login-box-line"></i>
                  Giriş Yap
                </>
              )}
            </button>
          </form>
        </div>

        {/* Test Bilgileri bölümü kaldırıldı */}
      </div>
    </div>
  );
}